<template>
  <v-combobox ref="campo"
    v-bind="attrs"
    :label="labelDefault"
    v-model="model"
    :items="options"
    :rules="rules"
    v-on="$listeners"
    :data-cy="attrs.label || attrs.name">
    <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
      <slot :name="slotName" v-bind="context" />
    </template>
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-if="!$scopedSlots.message" v-slot:message="{ message, key }">
      <v-icon v-if="$api.UI.showErrorIcon($el)" x-small color="error" class="mr-1 pb-1">{{$theme.options.iconError}}</v-icon>
      <span v-html="message" :key="key"></span>
    </template>
  </v-combobox>
</template>

<script>
export default {
  props: {
    options: { type: Array },
    value: null
  },
  methods: {
    open (timeout) {
      setTimeout(() => {
        this.$refs.campo.focus()
        this.$refs.campo.activateMenu()
      }, timeout || 0)
    }
  },
  computed: {
    labelDefault: function () {
      return (
        this.$attrs.label ? this.$attrs.label +
        (this.$attrs.required === '' || this.$attrs.required === true ? ' *' : '')
          : ''
      )
    },
    model: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    attrs () {
      return { ...this.$theme.options, ...this.$theme.options.combobox, ...this.$attrs }
    },
    rules () {
      const errors = []
      const name = this.$attrs.name || this.$attrs.label || ''
      if (this.$attrs.required === '' || this.$attrs.required === true) {
        (this.model === 0 || !!this.model) || errors.push(name + ' é obrigatório.')
      }
      if (this.$attrs['custom-rule'] === false) {
        errors.push(this.$attrs['custom-error'])
      } else if (
        this.$attrs['custom-rule'] &&
        this.$attrs['custom-rule'].length > 0
      ) {
        const cRules = this.$attrs['custom-rule']
        const cErrors = this.$attrs['custom-error']

        cRules.forEach((p, i) => {
          if (!cRules[i]) errors.push(cErrors[i])
        })
      }

      if (this.$refs && this.$refs.campo && this.$refs.campo.$el) {
        this.$refs.campo.$el.setAttribute(
          'data-message',
          errors ? errors[0] : ''
        )
        this.$refs.campo.$el.setAttribute('data-invalid', errors.length > 0)
      }

      return errors
    }
  },
  mounted () {
    this.$nextTick(function () {
      // Selecionar a primeira se houver somente 1 opção e for required
      if (
        !this.value &&
          this.options &&
          this.options.length === 1 &&
          (this.$attrs.required === '' || this.$attrs.required === true)
      ) {
        this.$emit('input', this.options[0])
      }
      const errors = this.rules
      this.$el.setAttribute('data-message', errors ? errors[0] : '')
      this.$el.setAttribute('data-invalid', errors.length > 0)
    })
  }
}
</script>
